export default __webpack_public_path__ + "static/tour_03_collaboration_discussion-6fbf759add17e66a25d66fabbfcb1e2e.jpg";